var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.reloadDataLoading,
          expression: "reloadDataLoading",
        },
      ],
      staticClass: "ds-control ds-navtree ds-tree ds-no-padding",
      class: {
        "tree-loaded": !_vm.loading,
        "has-btns": _vm.rowButtons.length > 0,
      },
      on: {
        mousedown: function ($event) {
          return _vm.mouseDownHandler($event)
        },
      },
    },
    [
      _c(
        "DsfPanel",
        {
          staticClass: "fit",
          attrs: { hasHeader: _vm.hasHeader },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [_vm._v(" " + _vm._s(_vm.label) + " ")]
              },
              proxy: true,
            },
          ]),
        },
        [
          [
            _c(
              "div",
              { staticClass: "searchbox" },
              [
                _vm._t("search", function () {
                  return [
                    _vm.openSearchBox
                      ? _c(
                          "el-input",
                          {
                            attrs: { placeholder: "请输入查询关键字" },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                _vm.filterText = _vm.filterTextVal
                              },
                            },
                            model: {
                              value: _vm.filterTextVal,
                              callback: function ($$v) {
                                _vm.filterTextVal = $$v
                              },
                              expression: "filterTextVal",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-input__icon el-icon-search",
                              attrs: { slot: "suffix", title: "检索" },
                              on: {
                                click: function ($event) {
                                  _vm.filterText = _vm.filterTextVal
                                },
                              },
                              slot: "suffix",
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                }),
                _vm._t("searchboxSolt"),
              ],
              2
            ),
            _c(
              "DsfVirtualScroll",
              {
                staticClass: "ds-tree-box",
                attrs: { "scroll-y": "", "scroll-x": "" },
              },
              [
                _c(
                  "el-tree",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$async && _vm.searchSqlUrl && _vm.filterText,
                          expression: "$async && searchSqlUrl && filterText",
                        },
                      ],
                      ref: "tree2",
                      attrs: {
                        "empty-text": _vm.searchLoaded
                          ? "暂无匹配数据"
                          : "数据查询中...",
                        "default-expand-all": true,
                        data: _vm.searchData,
                        "check-strictly": true,
                      },
                      on: {
                        "check-change": _vm.checkChange2,
                        "current-change": _vm.currNodeChange,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var node = ref.node
                              return _vm._t("default", function () {
                                return [
                                  _c("NavTreeNode", {
                                    attrs: { node: node },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "nodeLabel",
                                          fn: function (ref) {
                                            var data = ref.data
                                            return [
                                              _vm._t("nodeLabel", null, {
                                                data: data,
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              })
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    "el-tree",
                    _vm.elTreeAttrsCore,
                    false
                  )
                ),
                _c(
                  "el-tree",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.$async ||
                            !_vm.searchSqlUrl ||
                            _vm.filterText == "",
                          expression:
                            "!$async || !searchSqlUrl || filterText == ''",
                        },
                      ],
                      ref: "tree",
                      attrs: {
                        "empty-text": _vm.loading
                          ? "数据查询中..."
                          : "暂无数据",
                        "default-expanded-keys": _vm.expandedKeys,
                        lazy: _vm.$async,
                        "filter-node-method": _vm.filterNode,
                        "check-strictly": _vm.checkStrictly,
                        draggable: _vm.openDraggable,
                        "allow-drag": _vm.allowDrag,
                        "allow-drop": _vm.allowDrop,
                      },
                      on: {
                        "check-change": _vm.checkChange,
                        "current-change": _vm.currNodeChange,
                        "node-expand": _vm.nodeExpand,
                        "node-collapse": _vm.nodeCollapse,
                        "node-drag-start": _vm.handleDragStart,
                        "node-drag-enter": _vm.handleDragEnter,
                        "node-drag-leave": _vm.handleDragLeave,
                        "node-drag-over": _vm.handleDragOver,
                        "node-drag-end": _vm.handleDragEnd,
                        "node-drop": _vm.handleDrop,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var node = ref.node
                              return _vm._t("default", function () {
                                return [
                                  _c("NavTreeNode", {
                                    attrs: { node: node },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "nodeLabel",
                                          fn: function (ref) {
                                            var data = ref.data
                                            return [
                                              _vm._t("nodeLabel", null, {
                                                data: data,
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              })
                            },
                          },
                          {
                            key: "empty",
                            fn: function () {
                              return [
                                !_vm.loading ? _c("dsf-empty-data") : _vm._e(),
                                _vm.loading
                                  ? _c("span", [_vm._v("数据查询中...")])
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    "el-tree",
                    _vm.elTreeAttrs,
                    false
                  )
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }